import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ResearchScanStats } from './components/ResearchScanStats';
import { FilterOptions, FormData } from "./context/Form";

// use this way to expose the function as a global, otherwise webpack will replace the name with a shorter version
const container: HTMLElement | null = document.getElementById('rs-stats');

// tslint:disable-next-line no-null-keyword
if (container !== null) {

    const formdata: FormData = JSON.parse(
        container.getAttribute('data-formdata') as string,
    );

    const filteroptions: FilterOptions = JSON.parse(
        container.getAttribute('data-filteroptions') as string,
    );

    const canDownloadXls = container.getAttribute('data-canDownloadXls') ?? 'false';

    const ajaxUrl: string = container.getAttribute('data-ajaxUrl') as string;
    const nonce: string = container.getAttribute('data-nonce') as string;

    ReactDOM.render(
        <ResearchScanStats formdata={formdata} filteroptions={filteroptions} ajaxUrl={ajaxUrl} canDownloadXls={canDownloadXls} nonce={nonce} />,
        container,
    );
}

